/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowUpRightFromSquare } from 'icons'
import { icons } from "icons";


const UnderlineLink = (props) => {
    const link = props?.link;
    const style = props?.style;
    const format = props?.format;
    const link_type = link?.link_type;
    const isExternalLink = link_type === "external";
    const openInNewTab = link?.new_tab || isExternalLink;
    const linkTarget = openInNewTab ? "_blank" : "_self";

    return (
        <div className="simplicity-text-link-item">
            <a
                href={link?.url}
                className={`simplicity-underline-link ${style} ${format} ${
                    isExternalLink ? "link--icon link--icon--left" : ""
                }`}
                target={linkTarget}
            >
                {link?.text}

                {isExternalLink && (
                    <span className="simplicity-link-icon">
                        <FontAwesomeIcon icon={icons.regular.faArrowUpRightFromSquare} size="1x" />
                    </span>
                )}
            </a>
        </div>
    );
};

export { UnderlineLink };
